import { makeStyles } from '@material-ui/core'
import InValid from 'src/assets/My_Policies_Images/close.json'
import Lottie from 'lottie-react'
import keycloak from 'src/utils/commonMethods/keycloak'
import { invokeAllTypesSXP } from 'src/services/individualService'
import { useSelector } from 'react-redux'
import DefaultLogo from 'src/assets/PolicyDetails_Images/DefaultLogo.svg'
import { Tooltip, Zoom } from '@mui/material'
import {
  POLICY_STATUS_TYPE_ENUMS,
  POLICY_UPLOAD_METHOD,
} from 'src/utils/constants/common'
import { CLIENT, CLIENT_SMALLCASE } from 'src/utils/constants/Individual'

const ReUploadTile = ({
  policyDetails,
  handleDocumentDownload,
  handlePolicySelect,
  path,
}) => {
  const classes = useStyles()
  const { userInfo } = useSelector((state) => {
    return {
      userInfo: state?.userInfo,
    }
  })
  const invokeSxpUpload = (type) => {
    const sxpUploadBody = {
      state: {
        clientId:
          userInfo?.userInfo?.userData?.clientId == null
            ? userInfo?.userName
            : userInfo?.userInfo?.userData?.clientId,
        clientType: userInfo?.userInfo?.userData?.policyHolderType,
        createdBy: userInfo?.userName,
        updatedBy: userInfo?.userName,
        policy: policyDetails,
        email: userInfo?.userInfo?.userData?.emailId,
        token: keycloak?.token,
        roles: userInfo?.userInfo?.userData?.roles,
        url: path,
        clientTypeUrl:
          userInfo?.userInfo?.userData?.policyHolderType === CLIENT?.CORPORATE
            ? CLIENT_SMALLCASE?.CORPORATE
            : CLIENT_SMALLCASE?.INDIVIDUAL,
      },
      userId: userInfo?.userName,
    }
    invokeAllTypesSXP(sxpUploadBody, userInfo?.userName, type)
  }

  return (
    <div className={classes.mainContainer}>
      <div className={classes.tileContainer} onClick={handlePolicySelect}>
        <Tooltip
          TransitionComponent={Zoom}
          placement='bottom'
          title={
            <>
              <span>Download Document</span>
              <br />
              <span>
                Status: {POLICY_STATUS_TYPE_ENUMS?.[policyDetails?.status]}
              </span>
              <br />
              <span>AgentComments: {policyDetails?.agentComments}</span>
            </>
          }
          arrow
        >
          <div
            onClick={handleDocumentDownload}
            className={'cursor-pointer'}
            id='documentDownload'
          >
            <Lottie
              animationData={InValid}
              loop={true}
              className={classes.reUploadAnimation}
            />
          </div>
        </Tooltip>
        <div className={classes.tileDetailsContainer}>
          <img
            src={policyDetails.productImage ?? DefaultLogo}
            alt='Product'
            id='logo'
          />
          <span className={classes.reUploadText}>
            Please&nbsp;
            {policyDetails?.policyUploadedMethod ===
            POLICY_UPLOAD_METHOD?.manual ? (
              <span
                id='uploadLink'
                className={classes.uploadLink}
                onClick={(event) => {
                  event.stopPropagation()
                  // !policyDetails.agentComments || policyDetails.agentComments === ''
                  //   ? invokeSxpUpload('uploadDocumentTile')
                  //   : future use
                  invokeSxpUpload('policyUploadManual')
                }}
              >
                Re-Upload
              </span>
            ) : (
              <span
                id='uploadLink'
                className={classes.uploadLink}
                onClick={(event) => {
                  event?.stopPropagation()
                  invokeSxpUpload('digiUploadDocument')
                }}
              >
                Re-Upload
              </span>
            )}
            &nbsp; your {policyDetails?.insuranceType ?? 'Policy'}
          </span>
        </div>
      </div>
    </div>
  )
}

export default ReUploadTile

const useStyles = makeStyles({
  mainContainer: {
    border: '1px solid #D4D4D4',
    borderRadius: '10px',
    height: '100%',
  },
  tileContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    padding: '10px',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  tileDetailsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '5px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  reUploadText: {
    fontSize: '16px',
  },
  reUploadAnimation: {
    height: '80px',
    width: '80px',
  },
  uploadLink: {
    color: '#B92250',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
})
